import { captureError } from 'helpers/error'
import { action, makeObservable, observable, runInAction } from 'mobx'
import AuthStore from 'stores/AuthStore'
import Api from 'util/api'
import { DIContainer, DIInstances } from 'util/di'

export type AccountSetupFormData = {
  first_name?: string
  last_name?: string
  address_street_line_1?: string
  address_state?: string
  country?: string
  address_postal_code?: string
  dob_month?: string
  dob_day?: string
  dob_year?: string
  vecteezy_discovery_source?: string
  portfolio_links?: string[]
}

export default class AccountSetupStore {
  api: Api
  AuthStore: AuthStore

  constructor(container: DIContainer<DIInstances>) {
    makeObservable(this)
    this.api = container.find('api')
    this.AuthStore = container.find('AuthStore')
  }

  @observable currentStep = 1
  @observable completedSteps: number[] = []
  @observable updatingApplication = false
  @observable confirmingEmail = false

  @action setCurrentStep = (step: number): void => {
    this.currentStep = step
  }

  @action setCompletedSteps = (steps: number[]): void => {
    this.completedSteps = steps
  }

  @action confirmUserEmail = async (encodedEmail: string): Promise<void> => {
    try {
      this.confirmingEmail = true
      await this.api.request(
        'PATCH',
        `/api/v1/contributor_applications/confirm_email`,
        {
          body: { hash: encodedEmail },
        }
      )
    } catch (e) {
      captureError(
        e,
        'Error while confirming email - stores/AccountSetupStore.ts'
      )
      throw e
    } finally {
      runInAction(() => {
        this.confirmingEmail = false
      })
    }
  }

  @action updateContributorApplication = async (
    userId: string,
    data: AccountSetupFormData
  ): Promise<void> => {
    try {
      this.updatingApplication = true
      await this.api.request(
        'PATCH',
        `/api/v1/contributor_applications/${userId}`,
        {
          body: { user: { ...data } },
        }
      )
    } catch (e) {
      captureError(
        e,
        'Error while patch contributor setup - stores/AccountSetupStore.ts'
      )
      throw e
    } finally {
      runInAction(() => {
        this.updatingApplication = false
      })
    }
  }
}
